import { css } from '@emotion/css';

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    padding: 32px 16px;
    text-align: center;
  `,
  content: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  `,
};

export default styles;
